// client/src/components/common/PageShell.jsx
// Универсальный каркас страницы: страница на всю площадь,
// панели внутри с небольшими отступами.
// Никакой внешней «рамки» (её убрали из App.jsx).
import React from 'react';
import { Box } from '@mui/material';

/**
 * Корневой контейнер страницы.
 * Занимает всё доступное место внутри <main> (flex: 1).
 * Внутри — колонка со слотами (Header / Actions / Content).
 */
export default function PageShell({ children, sx = {} }) {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.75,
        p: 0.75,
        overflow: 'hidden',
        bgcolor: 'background.default',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
